<template lang="pug">
  button.btn.btn-icon.btn-line.FilterButton(
    type="button"
    @click="$emit('click')")
      IconConfig
</template>

<script>
export default {
  name: "FilterButton"
}
</script>

<style lang="scss" scoped>
  .FilterButton {
    color: $color-light;
    border-color: $color-shadow;
    width: 50px;
    background-color: white;
  }
</style>

